import { render, staticRenderFns } from "./diySelect.vue?vue&type=template&id=6e87fe9e&scoped=true&"
import script from "./diySelect.vue?vue&type=script&lang=js&"
export * from "./diySelect.vue?vue&type=script&lang=js&"
import style0 from "./diySelect.vue?vue&type=style&index=0&id=6e87fe9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87fe9e",
  null
  
)

export default component.exports